import { ReactNode } from 'react'
import styled from 'styled-components'
import RaisedButton from './RaisedButton/RaisedButton'

const SELECTION_BOX_WIDTH = 46
const SELECTION_BOX_HEIGHT = 48

type SelectionBoxProps = {
  className?: string
  children?: ReactNode
  isActive?: boolean
}

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`

const SelectionSurface = styled(RaisedButton)<{ $isVisible?: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${SELECTION_BOX_WIDTH}px;
  min-width: ${SELECTION_BOX_WIDTH}px;
  max-width: ${SELECTION_BOX_WIDTH}px;
  height: ${SELECTION_BOX_HEIGHT}px;
  min-height: ${SELECTION_BOX_HEIGHT}px;
  max-height: ${SELECTION_BOX_HEIGHT}px;
  border-radius: 8px;
  padding: 0;
  box-sizing: border-box;
  pointer-events: none;
  visibility: ${(props) => (props.$isVisible ? 'visible' : 'hidden')};
`

const Content = styled.div`
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  > svg {
    width: auto;
    height: auto;
    flex-shrink: 0;
  }
`

const SelectionBox = ({
  className,
  children,
  isActive = false
}: SelectionBoxProps) => {
  return (
    <Wrapper className={className}>
      <SelectionSurface $isVisible={isActive}>
        <></>
      </SelectionSurface>
      <Content>{children}</Content>
    </Wrapper>
  )
}

export default SelectionBox
